import React from "react";
import { css } from "emotion";
import LogoTitle from "./sidebar/LogoTitle";
import { deactivateMobileMenu } from "../utils/helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { colors } from "../styles/theme";
import MenuItem from "../components/sidebar/MenuItem";
import LogoutButton from "./sidebar/LogoutButton";

const MobileMenu = () => {
  return (
    <div id="mobile-menu" className={container}>
      <div className="top-row">
        <LogoTitle />
        <FontAwesomeIcon
          onClick={deactivateMobileMenu}
          className="icon"
          icon="times"
        />
      </div>
      <div className="links">
        <MenuItem route="home" />
        <MenuItem route="embed" />
        <MenuItem route="plans" />
        <MenuItem route="settings" />
        <LogoutButton />
      </div>
    </div>
  );
};

export default MobileMenu;

const container = css`
  position: fixed;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  z-index: -1;
  opacity: 0;
  transition-duration: 300ms;
  .top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0 40px 12px;
    .icon {
      color: ${colors.placeholderText};
      font-size: 24px;
      padding: 20px;
      height: 70px;
      width: 70px;
    }
  }

  .links {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`;

export const active = css`
  z-index: 100;
  opacity: 1;
`;
